import html from './employee-documents.html';
import lang from './employee-documents.lang.json';
import server from '../../../client/asis-server.js';
import * as mixins from '../../../client/globals/mixins.js';
import * as translators from '../../../client/globals/translators.js';


export default {
    template: html,

    i18n: {
        messages: lang
    },

    mixins: [mixins.module_name, mixins.loadDataOnCreate],

    data() {
        var $t = this.$t.bind(this);
        return {
            documents: [],
            loading: false,
            accepting: false,
            fields: [
                {key:'document_type', label:$t('document_type')},
                {key:'issued_date', label:$t('issued_date')},
                {key:'ref_num', label:$t('ref_num')},
                {key:'accept_timestamp', label:$t('accept_timestamp')},
                {key:'file', label:$t('file')},
            ],
        };
    },

    methods: {
        load() {
            this.loading = true;
            server.request(
                this.module_name, 'employee-documents-list', {}, null,
                (data) => {
                    this.documents = data;
                    if (this.documents.some(document => !document.accepted)) {
                        this.$nextTick(() => {
                            this.$bvModal.show('employee-documents-accept-modal');
                        });
                    }
                }
            ).then(() => {
                this.loading = false;
            });
        },

        accept_documents(event) {
            event.preventDefault();
            this.accepting = true;
            server.request(
                this.module_name, 'employee-documents-accept', {}, null,
                () => {
                    this.$bvModal.hide('employee-documents-accept-modal');
                    this.load();
                }
            ).then(() => {
                this.accepting = false;
            });
        },

        date_asis2ddmmyyyy: translators.date_asis2ddmmyyyy,
        datetime_timestamp2ddmmyyyy_hhmm: translators.datetime_timestamp2ddmmyyyy_hhmm,
        filesize_auto: translators.filesize_auto,
    },
};
